import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import {
    Card, CardContent, CardHeader, IconButton,
    Table, TableBody, TableCell, TableRow, Hidden
} from '@material-ui/core';

import { NumberSpinner } from '../../../components/InputControls'
import { withRouter } from 'react-router'
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px"
    }
}));

const GATicketCard = props => {

    const { products } = props;
    const [errorMsg, seterrorMsg] = useState("");
    const classes = useStyles();

    const changeQuantityHandler = (reference, value) => {
        props.changeQuantityHandler(reference, value);
    }

    const removeclickhandler = (ProductID) => {
        props.removeclickhandler(ProductID);
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const MaxTicketQuantity = (ProductID) => {
        let ticket = products.find(p => p.ProductID === ProductID);
        let fproduct = products.filter(p => p.ProductID === ProductID);
        let consumedQty = 0;
        if (fproduct && fproduct.length > 0) {
            consumedQty = fproduct.reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }
        return ticket.MaxQuantity - consumedQty;
    }

    const getTotalAmount = () => {
        let amount = {
            ticketamount: 0,
            tax: 0,
            total: 0,
        }

        products.forEach(ticket => {
            amount.ticketamount += ticket.OriginalTicketAmount;
            amount.tax += ticket.OriginalTaxAmount;
            amount.total += ticket.OriginalTotalAmount;
        });

        return amount;
    }
    return (
        <Card
            className={classes.root}
        >
            <CardHeader className={classes.tourheaderbox}
                title={"Tickets"}
                titleTypographyProps={{ color: "inherit" }}
            />
            <CardContent>
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Table size="small" className={classes.table} aria-label="spanning table">
                    <TableBody>
                        {products.map(ticket => (
                            <TableRow key={ticket.ProductID}>
                                <TableCell className={classes.tablecell} align="left">
                                    <IconButton
                                        edge="end"
                                        size="small"
                                        onClick={() => removeclickhandler(ticket.ProductID, ticket.OriginalPrice)}
                                    >
                                        <CancelIcon color={"error"} />
                                    </IconButton>
                                </TableCell>
                                <TableCell className={classes.tablecell}>{genfunction.IsNotNullOrEmptyOrUndefined(ticket.WebProductName) ? ticket.WebProductName : ticket.ProductName}</TableCell>
                                <TableCell className={classes.tablecell} align="right">
                                    <NumberSpinner refrence={{ eventId: ticket.ProductID, tourProductID: ticket.ProductID }}
                                        value={parseInt(ticket.Quantity)}
                                        minValue={ticket.MinQuantity} maxValue={ticket.MaxQuantity} steps={1}
                                        changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}></NumberSpinner>
                                </TableCell>
                                <Hidden smDown>
                                    <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(ticket.OriginalPrice)}</TableCell>
                                    <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(genfunction.priceRow(ticket.Quantity, ticket.OriginalPrice))}</TableCell>
                                </Hidden>
                                <Hidden smUp>
                                    <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(genfunction.priceRow(ticket.Quantity, ticket.OriginalPrice))}</TableCell>
                                </Hidden>
                            </TableRow>
                        ))}

                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.tablecell} colSpan={1}>Subtotal</TableCell>
                            <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().ticketamount)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.tablecell} colSpan={1}>Tax</TableCell>
                            <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().tax)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.tablecell} colSpan={2} />
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}>Total</TableCell>
                            <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(getTotalAmount().total)}</TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
};

GATicketCard.propTypes = {
    products: PropTypes.array.isRequired,
    removeclickhandler: PropTypes.func
};

export default withRouter(GATicketCard);
